import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';

const IconConditionUnknown = ({ width = 29, height = 28, fill = colors.neutralGray }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 29 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15.9683 20V23H12.9683V20H15.9683ZM14.4683 4.5C15.9922 4.43759 17.4789 4.98113 18.6033 6.01179C19.7276 7.04244 20.3982 8.47635 20.4683 10C20.4646 11.0166 20.1697 12.0108 19.6185 12.8651C19.0674 13.7193 18.283 14.3977 17.3583 14.82C17.0083 14.978 16.6523 15.118 16.2883 15.24L15.9683 15.35V18H12.9683V15C12.9683 13.21 14.4983 12.68 15.3183 12.4C15.5768 12.3176 15.8305 12.2207 16.0783 12.11C16.4868 11.9272 16.8347 11.6315 17.081 11.2577C17.3272 10.8839 17.4616 10.4476 17.4683 10C17.3947 9.27363 17.0394 8.60503 16.4786 8.13764C15.9177 7.67026 15.196 7.44134 14.4683 7.5C13.7405 7.44134 13.0188 7.67026 12.458 8.13764C11.8971 8.60503 11.5418 9.27363 11.4683 10V11H8.46826V10C8.53836 8.47635 9.20888 7.04244 10.3332 6.01179C11.4576 4.98113 12.9443 4.43759 14.4683 4.5ZM14.9683 0C7.23626 0 0.968262 6.268 0.968262 14C0.968262 21.732 7.23626 28 14.9683 28C22.7003 28 28.9683 21.732 28.9683 14C28.9683 10.287 27.4933 6.72601 24.8678 4.1005C22.2422 1.475 18.6813 0 14.9683 0ZM14.9683 26C8.34126 26 2.96826 20.627 2.96826 14C2.96826 7.373 8.34126 2 14.9683 2C21.5953 2 26.9683 7.373 26.9683 14C26.9683 17.1826 25.704 20.2348 23.4535 22.4853C21.2031 24.7357 18.1509 26 14.9683 26Z'
                fill={fill}
            />
        </svg>
    );
};

IconConditionUnknown.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    fill: PropTypes.string,
};

export default React.memo(IconConditionUnknown);
